import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { Agreement } from '@app/api/models/agreement';
import { useFetchData, useApi } from '@app/hooks';

import { useColumns } from './columns';
import { QueryTable } from '../common/table/query-table';

const AgreementsTable: FC = () => {
  const history = useHistory();

  const columns = useColumns();
  const api = useApi();
  const [fetchData] = useFetchData<Agreement>({ method: api.agreements.getAgreements });

  return (
    <>
      <QueryTable
        title="Соглашения"
        fetchData={fetchData}
        columns={columns}
        onCreateClick={() => history.push('/agreements/create')}
        canDownload
      />
    </>
  );
};

export default AgreementsTable;
